<template>
    <div class="mt-4">
        <div class="card course-calculator-card card-watermark" :style="errors.visa_checker ? 'border: 2px solid red;' : '' + ` --logo-url: url(${base_url}/storage/logo.png)`">
            <Accordion value="0">
                <AccordionPanel value="0">
                    <AccordionHeader>
                        <div class="accordion-header-content">
                            <div class="d-flex align-items-start">
                                <i class="fal fa-passport component-header-icon mt-0"></i>
                                <div>
                                    <h2 class="component-title">{{ tra.visa }}</h2>
                                    <p class="component-sub-title">{{ tra.select_visa }}</p>
                                    <p v-if="errors.visa_checker" class="text-danger">{{ errors.visa_checker[0] }}</p>
                                </div>
                            </div>
                        </div>
                    </AccordionHeader>
                    <AccordionContent>
                        
                        <div class="row align-items-end course-row py-2 justify-content-between">
                            <div class="col-12">
                                <div class="d-flex align-items-start">
                                    <RadioButton class="ml-3" v-model="visaCheckerValue" :value="0" />
                                    <div>
                                        <h2 class="course-title">{{ tra.no_visa }}</h2>
                                        <p class="course-sub-title">{{ tra.no_need_visa }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-end course-row py-2 justify-content-between">
                            <div class="col-md-auto">
                                <div class="d-flex align-items-start">
                                    <RadioButton class="ml-3" v-model="visaCheckerValue" :value="1" />
                                    <h2 class="course-title">{{ visa ? visa['name_'+lang] : '' }}</h2>
                                </div>
                            </div>
                            <div class="col-md-auto" style="padding-right: 52px;">
                                <div class="price-info d-flex align-items-end justify-content-md-end mt-2">
                                    <p class="price mb-0">
                                        {{ visa?.price }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </AccordionContent>
                </AccordionPanel>
            </Accordion>
        </div>
    </div>
</template>

<script>
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import RadioButton from 'primevue/RadioButton';
import debounce from 'lodash/debounce';

export default {
    components: {
        Accordion,
        AccordionPanel,
        AccordionHeader,
        AccordionContent,
        RadioButton,
    },
    props: ['country_id', 'base_url', 'pref_currency','course_weeks', 'visaChecker', 'courseWeeks', 'errors', 'old', 'tra'],
    emits: ['update:visaChecker', 'update:visaAvailability'],
    data() {
        return {
            visa: null,
            lang: window.current_locale,
            visaAbortController: null,
        };
    },
    methods: {
        getVisa() {
            // Cancel previous request if exists
            if (this.visaAbortController) {
                this.visaAbortController.abort();
            }

            // Create new AbortController for this request
            this.visaAbortController = new AbortController();

            axios.get(this.base_url + '/api/get-visa', {
                signal: this.visaAbortController.signal,
                params: {
                    country_id: this.country_id,
                    weeks: this.course_weeks,
                    pref_currency: this.pref_currency,
                },
            }).then((response) => {
                this.visa = response.data;
                // Emit visa data to parent whenever it's updated
                this.$emit('update:visaAvailability', this.visa ? true : false);
            }).catch((error) => {
                // Ignore cancelled requests
                if (error.code === 'ERR_CANCELED' || error.message === 'canceled') {
                    console.log('Visa request cancelled - new request started');
                    return;
                }
                console.error('Error fetching visa:', error);
            });
        },

        createDebouncedMethods() {
            this.debouncedGetVisa = debounce(this.getVisa, 500);
        },
    },
    computed: {
        visaCheckerValue: {
            get() {
                return this.visaChecker !== null ? Number(this.visaChecker) : null;
            },
            set(value) {
                this.$emit('update:visaChecker', value);
            }
        },
    },
    watch: {
        course_weeks: {
            handler() {
                this.debouncedGetVisa();
            },
            immediate: false
        },
        visa: {
            handler(newVisa) {
                if (newVisa) {
                    this.$emit('update:visaAvailability', newVisa ? true : false);
                }
            },
            deep: true
        }
    },
    created() {
        this.createDebouncedMethods();
    },
    mounted() {
        this.getVisa();
        if (this.old.visa_checker) {
            this.visaCheckerValue = Number(this.old.visa_checker);
        }
    },
};
</script>